import { render, staticRenderFns } from "./shetufuzhu.vue?vue&type=template&id=581e0b1b&"
import script from "./shetufuzhu.vue?vue&type=script&lang=ts&"
export * from "./shetufuzhu.vue?vue&type=script&lang=ts&"
import style0 from "./shetufuzhu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports